import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { Link, Typography } from 'transfix-ui/core'
import formatPhone from 'utils/formatPhone'
import { CONTACT_US_PHONE_NUMBER } from '../contactPhoneNumber'
import StepButtonContainer from './StepButtonContainer'
import StepCard from './StepCard'

interface INotEligibleStepProps {
  onCancel: () => void
}

const NotEligibleStep = ({ onCancel }: INotEligibleStepProps) => {
  const history = useHistory()
  const location = useLocation()
  const goToDashboardClickHandler = () => {
    history.push({ pathname: '/account-deletion/step/go-to-dashboard', search: location.search })
  }

  return (
    <StepCard title="We're Unable to Delete Your Account at this Time">
      <Typography variant='body2'>
        Our records indicate that you have incomplete loads. Be sure to check your active and past
        loads. Once these loads are completed and/or paid, come back and you&apos;ll be able to
        delete your account. If you need additional support, you can reach us at{' '}
        <Link href={`tel:${CONTACT_US_PHONE_NUMBER}`}>{formatPhone(CONTACT_US_PHONE_NUMBER)}</Link>.
      </Typography>

      <StepButtonContainer>
        <Button onClick={onCancel} color='tertiary'>
          Cancel
        </Button>
        <Button onClick={goToDashboardClickHandler} color='primary'>
          Go to My Dashboard
        </Button>
      </StepButtonContainer>
    </StepCard>
  )
}

export default NotEligibleStep
